module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hrms-staappr', {
    attrs: {
      "staappr": _vm.detail.staappr,
      "nowLang": _vm.nowLang,
      "currentDtereq": _vm.setDateOutput(_vm.currentDtereq),
      "currentNumseq": _vm.currentNumseq,
      "currentCodempidDisp": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-func"
  }, [_c('div', {
    staticClass: "box-topic border-color-skin"
  }, [_c('i', {
    staticClass: "fa fa-envelope margin-r-5 color-skin"
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin"
  }, [_vm._v(_vm._s(_vm.labels['HRES88EC2']['30']))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.numreqst))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['30']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-lov-codcomp', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "nowLang": _vm.nowLang,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codcomp",
      "name": "codcomp"
    },
    model: {
      value: (_vm.detail.codcomp),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codcomp", $$v)
      },
      expression: "detail.codcomp"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codcomp')),
      expression: "errors.has('codcomp')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codcomp')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['40']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lovType": "codpos",
      "nowLang": _vm.nowLang,
      "name": "codpos",
      "has-error": _vm.errors.has('codpos')
    },
    model: {
      value: (_vm.detail.codpos),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codpos", $$v)
      },
      expression: "detail.codpos"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codpos')),
      expression: "errors.has('codpos')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codpos')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['60']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lovType": "codjob",
      "nowLang": _vm.nowLang,
      "name": "codjob",
      "has-error": _vm.errors.has('codjob')
    },
    model: {
      value: (_vm.detail.codjob),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codjob", $$v)
      },
      expression: "detail.codjob"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codjob')),
      expression: "errors.has('codjob')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codjob')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['70']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "text-center",
    attrs: {
      "numLength": 5,
      "decimal": 0,
      "name": "qtyreq",
      "data-vv-name": "qtyreq",
      "has-error": _vm.errors.has('qtyreq')
    },
    model: {
      value: (_vm.detail.qtyreq),
      callback: function($$v) {
        _vm.$set(_vm.detail, "qtyreq", $$v)
      },
      expression: "detail.qtyreq"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('qtyreq')),
      expression: "errors.has('qtyreq')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('qtyreq')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['80']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lovType": "codempmt",
      "nowLang": _vm.nowLang,
      "name": "codempl",
      "has-error": _vm.errors.has('codempl')
    },
    model: {
      value: (_vm.detail.codempmt),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codempmt", $$v)
      },
      expression: "detail.codempmt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codempl')),
      expression: "errors.has('codempl')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codempl')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['90']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "data-vv-name": "dtereqm",
      "name": "dtereqm",
      "has-error": _vm.errors.has('dtereqm')
    },
    model: {
      value: (_vm.detail.dtereqm),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtereqm", $$v)
      },
      expression: "detail.dtereqm"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtereqm')),
      expression: "errors.has('dtereqm')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtereqm')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('hrms-num-input', {
    staticClass: "text-center",
    attrs: {
      "numLength": 4,
      "decimal": 0,
      "name": "v_year"
    },
    model: {
      value: (_vm.detail.v_year),
      callback: function($$v) {
        _vm.$set(_vm.detail, "v_year", $$v)
      },
      expression: "detail.v_year"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.labels['HRES88EC2']['110']))]), _vm._v(" "), _c('hrms-num-input', {
    staticClass: "text-center",
    attrs: {
      "numLength": 2,
      "decimal": 0,
      "name": "v_mth"
    },
    model: {
      value: (_vm.detail.v_mth),
      callback: function($$v) {
        _vm.$set(_vm.detail, "v_mth", $$v)
      },
      expression: "detail.v_mth"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.labels['HRES88EC2']['120']))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['130']))]), _vm._v(" "), _c('hrms-num-input', {
    staticClass: "align-right-input",
    attrs: {
      "numLength": 9,
      "name": "amtincom"
    },
    model: {
      value: (_vm.detail.amtincom),
      callback: function($$v) {
        _vm.$set(_vm.detail, "amtincom", $$v)
      },
      expression: "detail.amtincom"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['140']))]), _vm._v(" "), _c('hrms-dropdown', {
    attrs: {
      "options": _vm.dropdowns.codrearq[_vm.nowLang],
      "name": "codrearq"
    },
    model: {
      value: (_vm.detail.codrearq),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codrearq", $$v)
      },
      expression: "detail.codrearq"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "radio col-md-2",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgrecut),
      expression: "detail.flgrecut"
    }],
    attrs: {
      "type": "radio",
      "name": "flgrecut",
      "id": "flgrecut_r1",
      "value": "I"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgrecut, "I")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgrecut", "I")
      }
    }
  }), _vm._v(_vm._s(_vm.labels['HRES88EC2']['160']))])]), _vm._v(" "), _c('div', {
    staticClass: "radio col-md-2",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flgrecut),
      expression: "detail.flgrecut"
    }],
    attrs: {
      "type": "radio",
      "name": "flgrecut",
      "id": "flgrecut_r2",
      "value": "E"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flgrecut, "E")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flgrecut", "E")
      }
    }
  }), _vm._v(_vm._s(_vm.labels['HRES88EC2']['170']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['190']))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flgjob),
      expression: "flgjob"
    }],
    attrs: {
      "type": "checkbox",
      "name": "flgjob",
      "id": "flgjob",
      "value": "Y"
    },
    domProps: {
      "checked": Array.isArray(_vm.flgjob) ? _vm._i(_vm.flgjob, "Y") > -1 : (_vm.flgjob)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flgjob,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Y",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flgjob = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flgjob = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flgjob = $$c
        }
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES88EC2']['200']) + "\n                  ")])]), _vm._v(" "), (_vm.flgjob) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.v_syncond1),
      expression: "detail.v_syncond1"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "maxlength": "200",
      "name": "v_syncond1",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.detail.v_syncond1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "v_syncond1", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    staticClass: "form-control textarea-text",
    attrs: {
      "name": "v_syncond1",
      "readonly": "readonly"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flgcond),
      expression: "flgcond"
    }],
    attrs: {
      "type": "checkbox",
      "name": "flgcond",
      "id": "flgcond",
      "value": "Y"
    },
    domProps: {
      "checked": Array.isArray(_vm.flgcond) ? _vm._i(_vm.flgcond, "Y") > -1 : (_vm.flgcond)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.flgcond,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Y",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.flgcond = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.flgcond = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.flgcond = $$c
        }
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.labels['HRES88EC2']['210']) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('hrms-logical-statement', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateLogical),
      expression: "validateLogical"
    }],
    attrs: {
      "listFields": _vm.listFields,
      "disableMode": !_vm.flgcond,
      "nowLang": _vm.nowLang,
      "lists": _vm.clearLogical,
      "name": "v_syncond",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "Logical statement",
      "has-error": _vm.errors.has('Logical statement')
    },
    model: {
      value: (_vm.detail.v_syncond),
      callback: function($$v) {
        _vm.$set(_vm.detail, "v_syncond", $$v)
      },
      expression: "detail.v_syncond"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Logical statement')),
      expression: "errors.has('Logical statement')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('Logical statement')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES88EC2']['220']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desnote),
      expression: "detail.desnote"
    }],
    staticClass: "form-control textarea-text",
    staticStyle: {
      "height": "114px"
    },
    attrs: {
      "maxlength": "60",
      "name": "desnote"
    },
    domProps: {
      "value": (_vm.detail.desnote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desnote", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(60)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-6 col-sm-6  clear-padding"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.triggerToggle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db48b62c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres88e/detail.vue
// module id = 3991
// module chunks = 1